<!-- Header of template contains action buttons like download, mark as spam etc.. -->

<template>
  <v-row align="center" no-gutters v-if="!openInModal">
    <v-col sm="3" class="px-0">
      <v-icon
        @click="$router.go(-1)"
        class="pointer"
        :data-test-id="`${dataTestId}__back-to-all-emails-icon`"
        >arrow_back_ios</v-icon
      >
    </v-col>
    <v-col>
      <v-row no-gutters justify="end">
        <actionBtn
          :isSelected="true"
          :recipients="emitRecipientList"
          :archiveId="archiveIdVal"
          :hideBulk="hideBulk"
          :archives="archives"
          :typeEmail="typeEmail"
          :individualType="individualType"
          :dataTestId="dataTestId"
          :canDownloadEmail="canViewEmailBody"
        />
        <div class="pa-0 ml-2">
          <x-button
            :ripple="false"
            large
            color="#58e2c2"
            @click="openAttachmentDialogue"
            buttonText="Attachments"
            :data-test-id="`${dataTestId}__show-attachments-btn`"
          />
          <DownloadAttachmentDialogue
            :attachmentList="attachmentList"
          ></DownloadAttachmentDialogue>
          <SelectReceipientDialogue></SelectReceipientDialogue>
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import EventBus from '@/EventBus';
import ActionBtn from '@/components/Common/EmailAction';
import DownloadAttachmentDialogue from './DownloadAttachmentDialogue';
import SelectReceipientDialogue from './SelectReceipientDialogue';
export default {
  name: 'EmailTemplateArchivesHeader',
  components: {
    ActionBtn,
    DownloadAttachmentDialogue,
    SelectReceipientDialogue
  },
  props: [
    'openInModal',
    'emitRecipientList',
    'archiveIdVal',
    'hideBulk',
    'archives',
    'typeEmail',
    'attachmentList',
    'dataTestId',
    'canViewEmailBody'
  ],
  data() {
    return {
      individualType: 'Individual'
    };
  },
  methods: {
    openAttachmentDialogue() {
      EventBus.$emit('OPEN_DIALOGUE', true);
    }
  }
};
</script>
